import { Injectable } from '@angular/core';
import { BaseResponse } from '@models/common.model';
import { PopularFlightModel } from '@models/popular-flight.model';
import { HttpService } from '@services/http.service';
import { catchError, map, Observable, of } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class PopularFlightService {
    constructor(private _http: HttpService) {}

    /**
     * Get cheap flight
     *
     * @param {number} id
     * @return {*}  {Observable<PopularFlightModel[]>}
     * @memberof PopularFlightService
     */
    public getPopularFlight(): Observable<PopularFlightModel[] | []> {
        return this._http
            .get<BaseResponse<PopularFlightModel[]>>(`PopularFlight/UserViewPopularFlight`)
            .pipe(
                catchError(() => {
                    return of(new BaseResponse<PopularFlightModel[]>({ Data: [] }));
                }),
                map((res) => res.Data || [])
            );
    }
}
